import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { Calendar, Clock, ArrowLeft, Tag } from 'lucide-react'
import { blogPosts } from '../data/blogPosts'

const BlogDetailPage = () => {
  const { slug } = useParams()
  const post = blogPosts.find(p => p.slug === slug)

  if (!post) {
    return (
      <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="1:1" data-component-id="client/src/pages/BlogDetailPage.jsx:1:1" className="min-h-screen flex items-center justify-center">
        <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="2:2" data-component-id="client/src/pages/BlogDetailPage.jsx:2:2" className="text-center">
          <h1 data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="3:3" data-component-id="client/src/pages/BlogDetailPage.jsx:3:3" className="text-4xl font-bold text-gray-900 mb-4">Blog yazısı bulunamadı</h1>
          <Link data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="4:4" data-component-id="client/src/pages/BlogDetailPage.jsx:4:4" to="/blog" className="text-blue-600 hover:text-blue-700 font-medium">
            Blog sayfasına dön
          </Link>
        </div>
      </div>
    )
  }

  const relatedPosts = blogPosts
    .filter(p => p.category === post.category && p.id !== post.id)
    .slice(0, 3)

  return (
    <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="5:5" data-component-id="client/src/pages/BlogDetailPage.jsx:5:5" className="min-h-screen bg-gray-50">
      <article data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="6:6" data-component-id="client/src/pages/BlogDetailPage.jsx:6:6" className="bg-white">
        <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="7:7" data-component-id="client/src/pages/BlogDetailPage.jsx:7:7" 
          className="relative h-96 bg-cover bg-center"
          style={{ backgroundImage: `url(${post.image})` }}
        >
          <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="8:8" data-component-id="client/src/pages/BlogDetailPage.jsx:8:8" className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent"></div>
        </div>

        <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="9:9" data-component-id="client/src/pages/BlogDetailPage.jsx:9:9" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-32 relative z-10">
          <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="10:10" data-component-id="client/src/pages/BlogDetailPage.jsx:10:10" className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <Link data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="11:11" data-component-id="client/src/pages/BlogDetailPage.jsx:11:11"
              to="/blog"
              className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium mb-6"
            >
              <ArrowLeft className="w-4 h-4" />
              Blog'a Dön
            </Link>

            <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="12:12" data-component-id="client/src/pages/BlogDetailPage.jsx:12:12" className="flex items-center gap-3 mb-6">
              <span data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="13:13" data-component-id="client/src/pages/BlogDetailPage.jsx:13:13" className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium flex items-center gap-2">
                <Tag className="w-4 h-4" />
                {post.category}
              </span>
            </div>

            <h1 data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="14:14" data-component-id="client/src/pages/BlogDetailPage.jsx:14:14" className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {post.title}
            </h1>

            <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="15:15" data-component-id="client/src/pages/BlogDetailPage.jsx:15:15" className="flex items-center gap-6 text-gray-600 mb-8 pb-8 border-b">
              <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="16:16" data-component-id="client/src/pages/BlogDetailPage.jsx:16:16" className="flex items-center gap-2">
                <Calendar className="w-5 h-5" />
                <span data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="17:17" data-component-id="client/src/pages/BlogDetailPage.jsx:17:17">{post.date}</span>
              </div>
              <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="18:18" data-component-id="client/src/pages/BlogDetailPage.jsx:18:18" className="flex items-center gap-2">
                <Clock className="w-5 h-5" />
                <span data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="19:19" data-component-id="client/src/pages/BlogDetailPage.jsx:19:19">{post.readTime}</span>
              </div>
            </div>

            <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="20:20" data-component-id="client/src/pages/BlogDetailPage.jsx:20:20" 
              className="prose prose-lg max-w-none prose-headings:text-gray-900 prose-p:text-gray-700 prose-a:text-blue-600 prose-strong:text-gray-900"
              dangerouslySetInnerHTML={{ __html: post.content.replace(/\n/g, '<br/>') }}
            />
          </div>
        </div>
      </article>

      {relatedPosts.length > 0 && (
        <section data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="21:21" data-component-id="client/src/pages/BlogDetailPage.jsx:21:21" className="py-20 bg-gray-50">
          <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="22:22" data-component-id="client/src/pages/BlogDetailPage.jsx:22:22" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="23:23" data-component-id="client/src/pages/BlogDetailPage.jsx:23:23" className="text-3xl font-bold text-gray-900 mb-8">İlgili Yazılar</h2>
            <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="24:24" data-component-id="client/src/pages/BlogDetailPage.jsx:24:24" className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {relatedPosts.map((relatedPost) => (
                <Link data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="25:25" data-component-id="client/src/pages/BlogDetailPage.jsx:25:25"
                  key={relatedPost.id}
                  to={`/blog/${relatedPost.slug}`}
                  className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
                >
                  <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="26:26" data-component-id="client/src/pages/BlogDetailPage.jsx:26:26" className="relative h-48 overflow-hidden">
                    <img data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="27:27" data-component-id="client/src/pages/BlogDetailPage.jsx:27:27"
                      src={relatedPost.image}
                      alt={relatedPost.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="28:28" data-component-id="client/src/pages/BlogDetailPage.jsx:28:28" className="p-6">
                    <h3 data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="29:29" data-component-id="client/src/pages/BlogDetailPage.jsx:29:29" className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2">
                      {relatedPost.title}
                    </h3>
                    <p data-component-path="client/src/pages/BlogDetailPage.jsx" data-component-line="30:30" data-component-id="client/src/pages/BlogDetailPage.jsx:30:30" className="text-gray-600 text-sm line-clamp-2">
                      {relatedPost.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  )
}

export default BlogDetailPage